'use es6';
import { css } from 'styled-components';
import { MODAL_BACKGROUND_TRANSITION_TIMING } from 'HubStyleTokens/times';

export const getOverlayTransition = (dialogTransitionTime) => css`
  .private-modal-dialog--overlay {
    transition-property: ${({ transitioning }) =>
      transitioning ? 'background-color' : 'none'};
    transition-delay: ${({ open }) => (open ? 0 : dialogTransitionTime)}ms;
    transition-duration: ${MODAL_BACKGROUND_TRANSITION_TIMING};
    background-color: ${({ open }) =>
      `rgba(45, 62, 80, ${open ? '0.79' : '0'})`};
  }
`;
